import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import '@/assets/font/font.css'
import '@/assets/style/index.scss'

// 网站标题
let title = '托运侠-全国电动车托运摩托车托运-全国可寄-整车托运-不拆电瓶-上门取件-专业木架包装'
document.title = title;

createApp(App).use(router).use(Antd).mount('#app')

